import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2f3479d0&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=2f3479d0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3479d0",
  null
  
)

export default component.exports